import { useMutation } from "@tanstack/react-query";

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import style from "../../styles/form.module.css";
import { Estado } from "../../actions/Estado";
import { Perfil } from "../../actions/Perfil";

function ABMUsuarios() {
   var metodo = "PUT";
   const [onChange, setOnChange] = useState(false);
   const [mailError, setMailError] = useState("");
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "users";
   var urlUsr = process.env.REACT_APP_URL_DIR + "registernoAUth";
   // var urlUser = url;
   const estados = Estado();
   const perfiles = Perfil();

   const location = useLocation();
   const { state } = location;
   const navigate = useNavigate();
   const [input, setInput] = useState({
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      username: state ? state.username : "",
      email: state ? state.email : 0,
      passwordHash: "",
      perfilusuarios: state ? state.perfilusuarios : [],
      estadoId: state ? state.estadoId : "1",
      id_rank: state ? state.id_rank : 0,
      nombrecompleto:state ? state.nombrecompleto : 0,
   });

   const [usuario, setUsuario] = useState({
      id: 0,
      companyId: state ? state.id : 0,
      username: "",
      email: "",
      passwordHash: "",
      perfiles: [2],
      estadoId: 1,
      id_rank: 0,
      nombrecompleto:"",
   });

   console.log("perfiles: ", perfiles);
   console.log("state: ", state);
   var btnGrabar = true;

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }
   function handleAddPerf(e) {
      e.preventDefault();

      const yaingresado = input.perfilusuarios.find(
         (element) => parseInt(element.id) === parseInt(e.target.value)
      );
      if (yaingresado) {
         var newPerfil = [];
         for (let i = 0; i < input.perfilusuarios.length; i++) {
            if (
               parseInt(input.perfilusuarios[i].id) !== parseInt(e.target.value)
            ) {
               newPerfil.push(input.perfilusuarios[i]);
            }
         }
         input.perfilusuarios = newPerfil;
         console.log("ya esta", yaingresado, newPerfil);
         console.log("input.perfilusuarios: ", input.perfilusuarios);
         // if (onChange) {
         //    setOnChange(false);
         // } else {
         //    setOnChange(true);
         // }
         // return;
      } else {
         const found = perfiles.find(
            (element) => parseInt(element.id) === parseInt(e.target.value)
         );
         console.log("found: ", found);
         if (found) {
            input.perfilusuarios.push(found);
         }
      }
      try {
         // console.log(url + "/" + input.id + "/perfiles");
         newPerfil = [];
         for (let index = 0; index < input.perfilusuarios.length; index++) {
            newPerfil.push(input.perfilusuarios[index].id);
         }
         console.log("input: ", input);
         console.log("handleAddPerf: ", newPerfil);
         // const newper = api.post(url+'/'+input.id+'/perfiles',[2,3])

         fetch(url + "/" + input.id_rank + "/perfiles", {
            method: "POST",
            body: JSON.stringify(newPerfil),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json());
      } catch (error) {
         console.log("error: ", error);
      }
      if (onChange) {
         setOnChange(false);
      } else {
         setOnChange(true);
      }
   }
   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("handleSubmit : ", input);
      // urlUser = url + `/${input.id}`;
      usuario.id = input.id;
      usuario.companyId = input.companyId;
      usuario.username = input.username;
      usuario.email = input.email;
      usuario.passwordHash = input.passwordHash;
      usuario.perfiles = input.perfilusuarios;
      usuario.estadoId = input.estadoId;
      usuario.id_rank = input.id_rank;
      usuario.nombrecompleto = input.nombrecompleto;
      if (input.id === 0) {
         usuario.perfiles = [2];
         metodo = "POST";
      } else {
         metodo = "PUT";
         urlUsr = process.env.REACT_APP_URL_DIR + "users/" + input.id_rank;
         usuario.perfiles = []
         for (let i = 0; i < input.perfilusuarios.length; i++) {
            usuario.perfiles.push(input.perfilusuarios[i].id)
         }         
      }
      console.log("handleSubmit: ", usuario);
      mutate(usuario);
   };

   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(urlUsr, {
            method: metodo,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: (req) => {
         console.log("req: ", req);
         if (req.errors) {
            for (let ix = 0; ix < req.errors.length; ix++) {
               if (req.errors[ix].path === "email")
                  setMailError(req.errors[ix].msg);
            }
         } else {
            window.location.href = "/Usuario";
         }
      },
      onFailure: (response) => {
         console.log("fallo", response);
      },
      onError: (error) => {
         console.log("Error", error);
         alert("Error");
      },
   });

  console.log("input: ", input);

   // console.log("input.perfilusuarios: ", input.perfilusuarios);
   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">Datos del Usuario</h1>
                  <br />
                  {/* <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Usuario id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div> */}

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Nombre: </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Ingrese nombre del Usuario"
                        name="nombrecompleto"
                        id="nombrecompleto"
                        value={input.nombrecompleto}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div style={{ display: "block" }}>
                     <div className={style.input_group}>
                        <span className={style.input_group_text}>E-Mail: </span>
                        <input
                           className={style.input_field}
                           type="text"
                           placeholder="Email del Usuario"
                           name="email"
                           value={input.email}
                           onChange={handleChange}
                           required
                        />
                     </div>
                     <div className={style.showerror}>
                        <p className={style.errormsg}>{mailError}</p>
                     </div>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>ID: </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Ingrese nombre del Usuario"
                        name="username"
                        value={input.username}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        CLave de acceso:{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="password"
                        placeholder="Ingrese una clave "
                        name="passwordHash"
                        value={input.passwordHash}
                        onChange={handleChange}
                        required
                     />
                  </div>
                  {input.id > 0 ? (
                     <>
                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Perfil:
                           </span>
                           {input.perfilusuarios &&
                              input.perfilusuarios.map((per) => {
                                 return (
                                    <div
                                       key={per.id}
                                       className={style.perfiles}
                                    >
                                       &nbsp;{per.nombre}&nbsp;&nbsp;&nbsp;
                                    </div>
                                 );
                              })}
                        </div>

                        <div className={style.input_group}>
                           <span className={style.input_group_text}>
                              Perfiles:
                           </span>
                           <select
                              name="perfil"
                              id="perfil"
                              onChange={(e) => handleAddPerf(e)}
                              value={0}
                              className={style.input_field}
                           >
                              <option value="0">Seleccionar</option>
                              {perfiles &&
                                 perfiles.map((perf) => {
                                    return (
                                       <option
                                          selected
                                          value={perf.id}
                                          key={perf.id}
                                       >{`${perf.nombre}`}</option>
                                    );
                                 })}{" "}
                           </select>
                        </div>
                     </>
                  ) : null}
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="estadoId"
                        id="estadoId"
                        onChange={(e) => handleChange(e)}
                        value={input.estadoId}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/Usuario");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMUsuarios;
